import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  pushBottomPanel,
  pushLeftPanel,
  pushBottomLegendPanel
} from "../../actions/dashboard";
import Mapmaster from "../../granular/Portal/mapmaster";
import { fetchPorts, fetchDistrict } from "../../api/portal";

class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: 5.5,
      open: false,
      center: [118.15, -3.1],
      port: [],
      district: []
    };
  }
 

  componentDidMount() {
    this.props.pushBottomPanel(true);
  }

  render() {
    return (
      <Mapmaster
        center={this.state.center}
        zoom={this.state.zoom}
      />
    );
  }
}

Portal.propTypes = {
  classes: PropTypes.object.isRequired,
  pushBottomPanel: PropTypes.bool
  // pushLeftPanel: PropTypes.bool,
  // pushShipFinder: PropTypes.array,
  // pushLoader: PropTypes.bool,
  // pushBottomLegendPanel
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    basemap: state.basemap,
    dateversion: state.dateversion,
    bottomPanel: state.bottomPanel,
    bottomLegendPanel: state.bottomLegendPanel,
    leftPanel: state.leftPanel,
    checkedPOI: state.checkedPOI,
    basemapLegend: state.basemapLegend,
    shipFinder: state.shipFinder,
    basemapAsli: state.basemapAsli,
    distinctCheck: state.distinctCheck
  };
}

export default connect(
  mapStateToProps,
  {
    pushBottomPanel
    // pushBottomLegendPanel,
    // pushLeftPanel,
    // pushShipFinder,
    // pushLoader
  }
)(Portal);
